export class Statuscategory {

  public colorName: string;
  public id: number;
  public key: string;

  constructor(colorName: string, id: number, key: string) {
    this.colorName = colorName;
    this.id = id;
    this.key = key;
  }
}

